<template>
    <div>


        
            <h5>[{{ projectId }}] {{ projectName }}</h5>
            <hr>
            <b-row>
                <b-col cols="auto" class="mr-auto">
                </b-col>
                <b-col cols="auto" class="">
                    <b-form-group>
                        <b-button variant="github" class="mr-1 btn-brand" @click="openProductModal(null)"><i class="fa fa-plus"></i><span>Novo Item</span></b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            
            <h5>Produtos</h5>


            <b-table :items="productItems" :fields="prospectTable.fields" :select-mode="prospectTable.selectMode" responsive="sm" primary-key="id" 
                    :tbody-transition-props="prospectTable.transProps" sort-icon-left
                    per-page="50" current-page="1" :busy="prospectTable.isBusy" hover striped>

                <template v-slot:cell(quantity)="data">
                    <b-form-input
                    type="number"
                    v-model.number="data.item.quantity"
                    @input="updateProductTotal(data.index)"
                    @blur="blurProductTotal(data.index)"
                    ></b-form-input>
                </template>

                <template v-slot:cell(unitaryValue)="data">
                    <b-form-input
                    type="number"
                    v-model.number="data.item.unitaryValue"
                    @input="updateProductTotal(data.index)"
                    @blur="blurProductTotal(data.index)"
                    ></b-form-input>
                </template>

                <template v-slot:cell(itemDiscount)="data">
                    <b-form-input
                    type="number"
                    v-model.number="data.item.discount"
                    readonly
                    ></b-form-input>
                </template>

                <template v-slot:cell(totalValue)="data">
                    <!--<b-form-input
                    type="number"
                    v-model.number="data.item.totalValue"
                    ></b-form-input>
                    -->
                    {{ data.item.totalValue ? data.item.totalValue.toFixed(2) : "0,00" }}

                </template>

                <template v-slot:cell(action)="data">
                    <b-button size="sm" variant="danger" @click="deleteItem(data.item)" class="mr-1 btn-brand"><i class="fa fa-times"></i></b-button>                  
                </template>

            </b-table>

            
            <hr>
            <b-row>
                <b-col class="text-right">
                    Total (Produtos):
                </b-col>
                <b-col class="text-right" cols="2" style="padding-right: 30px">
                    {{ tProduct ? tProduct.toFixed(2) : "0,00" }}
                </b-col>
            </b-row>

            <hr>
      

            <h5>Serviços</h5>


            <b-table :items="serviceItems" :fields="prospectTable.fields" :select-mode="prospectTable.selectMode" responsive="sm" primary-key="id" 
                    :tbody-transition-props="prospectTable.transProps" sort-icon-left
                    per-page="50" current-page="1" :busy="prospectTable.isBusy" hover striped>
                    
                <template v-slot:cell(quantity)="data">
                    <b-form-input
                    type="number"
                    v-model.number="data.item.quantity"
                    @input="updateServiceTotal(data.index)"
                    @blur="blurServiceTotal(data.index)"
                    ></b-form-input>
                </template>

                <template v-slot:cell(unitaryValue)="data">
                    <b-form-input
                    type="number"
                    v-model.number="data.item.unitaryValue"
                    @input="updateServiceTotal(data.index)"
                    @blur="blurServiceTotal(data.index)"
                    ></b-form-input>
                </template>

                <template v-slot:cell(itemDiscount)="data">
                    <b-form-input
                    type="number"
                    v-model.number="data.item.discount"
                    readonly
                    ></b-form-input>
                </template>

                <template v-slot:cell(totalValue)="data">
                    <!--
                    <b-form-input
                    type="number"
                    v-model.number="data.item.totalValue"
                    ></b-form-input>
                    -->
                    {{ data.item.totalValue ? data.item.totalValue.toFixed(2) : "0,00" }}

                </template>

                <template v-slot:cell(action)="data">
                    <b-button size="sm" variant="danger" @click="deleteItem(data.item)" class="mr-1 btn-brand"><i class="fa fa-times"></i></b-button>                  
                </template>

            </b-table>

            <hr>
            <b-row>
                <b-col class="text-right">
                    Total (Serviços):
                </b-col>
                <b-col class="text-right" cols="2" style="padding-right: 30px">
                    {{ tService ? tService.toFixed(2) : "0,00" }}
                </b-col>
            </b-row>


            <hr>
            <b-row>
                <b-col class="text-right">
                    Total (Produtos + Serviços):
                </b-col>
                <b-col class="text-right" cols="2" style="padding-right: 30px">
                    {{ ((tProduct && tProduct > 0 ? tProduct : 0) + (tService && tService > 0 ? tService : 0)).toFixed(2) }}
                </b-col>
            </b-row>

        
        <b-modal v-model="productModal"
              id="product-modal"
              centered
              hide-footer
              title="Produtos"
              size="xl">
              
              <product-select-component
                :companyId="companyId"
                @product-selected="productSelected"
              ></product-select-component>
           
        </b-modal>
    </div>    
</template>

<script>
import Vue from 'vue'
import axios from "axios";

import ProductSelectComponent from '../stock/ProductSelectComponent'

export default {
    name: 'projectProductComponent',
    props: {
        prospectId: String,
        
        projectName: String,
        projectId: Number,
        
        companyId: String
    },
    watch: {
     
        projectId: {
            immediate: true,
            handler(newValue) {
                this.refreshData()
            }
        }
    },
    components: {
        ProductSelectComponent
    },
    data: () => {
        return {

            tProduct: 0,
            tService: 0,
           
            productModal: false,

            productItems: [],
            serviceItems: [],

            prospectTable: {
                fields: [
                    { key: 'action', label: '', sortable: false, thStyle: { width: "40px" } },
                    { key: 'product.name', label: 'Produto', sortable: true },
                    { key: 'unitaryValue', label: 'Valor Unitário', thStyle: { width: "120px" } },
                    { key: 'quantity', label: 'Quantidade', thStyle: { width: "120px" } },
                    //{ key: 'itemDiscount', label: 'Desconto', sortable: false, thStyle: { width: "120px" } },
                    { key: 'totalValue', label: 'Valor Total', thStyle: { width: "120px" }, tdClass: 'text-right' }
                    //{ key: 'description', label: 'Descrição', sortable: true},
                    //{ key: 'action2', label: '', sortable: false, thStyle: { width: "40px" } },                    
                ],
                selectMode: 'single',
                isBusy: false,
                primaryKey: "id",
                transProps: {
                    name: 'flip-list'
                }

            },
            
        }
    },
    computed: {
       
    },
    methods: {

        blurProductTotal(index) {
            const item = this.productItems[index];
            item.totalValue = item.quantity * item.unitaryValue;
            this.totalProduct()
            this.updateItem(item)
        },

        blurServiceTotal(index) {
            const item = this.serviceItems[index];
            item.totalValue = item.quantity * item.unitaryValue;
            this.totalService()
            this.updateItem(item)
        },

        updateProductTotal(index) {
            const item = this.productItems[index];
            item.totalValue = item.quantity * item.unitaryValue;
            this.totalProduct()
        },

        updateServiceTotal(index) {
            const item = this.serviceItems[index];
            item.totalValue = item.quantity * item.unitaryValue;
            this.totalService()           
        },

        totalProduct() {
            var total = 0
        
            if(this.productItems) {
                this.productItems.forEach(item => {
                    if(item.totalValue && item.totalValue >= 0)
                        total = total + item.totalValue                    
                })
            }
            this.tProduct = total

            
        },

        totalService() {
            var total = 0
            if(this.serviceItems) {
                this.serviceItems.forEach(item => {
                    if(item.totalValue && item.totalValue >= 0) {
                        total = total + item.totalValue
                    }
                })
            }
            this.tService = total
        },

        async updateItem(item) {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            if(item && item.id && item.id > 0) {
                if(item.unitaryValue && item.unitaryValue >= 0 && item.quantity && item.quantity >= 0) {
                    console.log("Item alterado")
                    console.log(item)

                    item["uid"] = currentUser.id
                    item["sid"] = currentUser.sid

                    await axios.put(
                        this.$store.state.ws_url + "/prospect/item",
                        item
                    ).then(function(resp) {
                        console.log("Item alterado ")
                    }).catch(function(error) {
                        console.log(error)
                    })
                }
            }
        },
        
        async deleteItem(item) {
            var s = this;
            var currentUser = this.$store.state.currentUser;

            await axios.delete(
                this.$store.state.ws_url + "/prospect/item?itemId=" + item.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid,
            ).then(function(resp) {
                s.refreshData()
            }).catch(function(error) {
                console.log(error)
            })

        },
        openProductModal(item) {
            this.productModal = true
        },
        closeProductModal() {
            this.productModal = false
        },
        async productSelected(selectedItems) {

            var s = this;
            var currentUser = this.$store.state.currentUser;

            this.closeProductModal();
         
            if(selectedItems && selectedItems.length > 0) {
            
                var postData = {}
                postData["projectId"] = this.projectId
                postData["productId"] = selectedItems[0].id
                postData["unitaryValue"] = selectedItems[0].unitaryValue
                postData["quantity"] = 1
                postData["totalValue"] = selectedItems[0].unitaryValue
                postData["uid"] = currentUser.id
                postData["sid"] = currentUser.sid

                await axios.post(
                    this.$store.state.ws_url + "/prospect/item",
                    postData
                ).then(function(resp) {
                    s.refreshData()
                }).catch(function(error) {
                    console.log(error)
                })
            }
        },

        async getProduct() {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            
           
            await axios.get(
                this.$store.state.ws_url + "/prospect/item?projectId=" + s.projectId + "&isService=false&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function(resp) {
                s.productItems = resp.data.obj;
                s.totalProduct()
            
            }).catch(function(error) {
                console.log(error)
                s.productItems = []
            })
        },

        async getService() {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            
           
            await axios.get(
                this.$store.state.ws_url + "/prospect/item?projectId=" + s.projectId + "&isService=true&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function(resp) {
                s.serviceItems = resp.data.obj;
                s.totalService()
                
            }).catch(function(error) {
                console.log(error)
                s.serviceItems = []
            })
        },

        refreshData() {
            this.getProduct()
            this.getService()
          
        }
    }

}

</script>